import { useTranslation } from 'core/i18n';
import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';

export interface BulkDeactivateCustomAlarmsComponentProps {
    onClick: VoidFunction;
}

export const BulkDeactivateCustomAlarmsComponent: React.FC<BulkDeactivateCustomAlarmsComponentProps> = (props) => {
    const { onClick } = props;
    const { t } = useTranslation();

    return (
        <BulkActionButtonComponent
            onClick={onClick}
            text={t('settings.devices.custom-alarms.actions.deactivate')}
            iconName="circle_remove"
        />
    );
};
